globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.BackgroundVideo = (function() {
  function BackgroundVideo($html) {
    this.$html = $html;
    this.$playButton = $html.find('.background-video-play-button');
    this.video = $html.find('video')[0];
  }

  BackgroundVideo.prototype = {
    init: function() {
      if(this.$playButton.length > 0 && this.video) {
        this.playButtonEvents();
      }
    },
    playButtonEvents: function() {
      var element= this;

      element.$playButton.on('click', function () {
        if (element.video.paused) {
          element.playVideo();
        } else {
          element.pauseVideo();
        }
      });
    },
    playVideo: function() {
      this.video.play();
      this.$playButton.attr('aria-pressed', 'false');
      this.$playButton.attr('aria-label', 'Pauser la vidéo');
    },
    pauseVideo: function() {
      this.video.pause();
      this.$playButton.attr('aria-pressed', 'true');
      this.$playButton.attr('aria-label', 'Lancer la vidéo');
    },
  };

  return BackgroundVideo;
})();
